// src/components/users/ProjectsModal.js
import { useState, useEffect } from 'react';
import api from '../../services/api';

const ProjectsModal = ({ user, allProjects, onClose, onSave }) => {
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  const [selectedProjects, setSelectedProjects] = useState(user.projects?.map(p => p.id) || []);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    setSelectedProjects(user.projects?.map(p => p.id) || []);
  }, [user]);

  const handleProjectToggle = (projectId) => {
    setSelectedProjects(prev =>
      prev.includes(projectId)
        ? prev.filter(id => id !== projectId)
        : [...prev, projectId]
    );
  };

  const handleSave = async () => {
    setLoading(true);
    setError('');
    try {
      // Обновляем проекты и роли вместе
      const response = await api.patch(`/user/${user.id}/projects`, {
        projects: selectedProjects,
        role_ids: user.roles?.map(r => r.id) || []
      });
      console.log('Response from save:', response);
      console.log('Response data:', response.data);
      
      // Проверяем, что ответ успешный
      if (response.data?.success) {
        onSave(selectedProjects);
        onClose();
      } else {
        // Если success false, считаем это ошибкой
        throw new Error(response.data?.error || 'Ошибка при сохранении проектов');
      }
    } catch (err) {
      console.error('Error details:', err);
      console.error('Error response:', err.response);
      console.error('Error response data:', err.response?.data);
      setError(err.response?.data?.error || err.message || 'Ошибка при сохранении проектов');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal show" style={{ display: 'block' }} onClick={handleBackdropClick}>
      <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>

        <div className="modal-content">

          <div className="modal-header">
            <h5 className="modal-title">Проекты пользователя: {user.username}</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            {error && <div className="alert alert-danger">{error}</div>}
            
            <div className="projects-list">
              {allProjects.length === 0 ? (
                <p>Нет доступных проектов</p>
              ) : (
                allProjects.map(project => (
                  <div key={project.id} className="form-check">
                    <input
                      type="checkbox"
                      id={`project-${project.id}`}
                      className="form-check-input"
                      checked={selectedProjects.includes(project.id)}
                      onChange={() => handleProjectToggle(project.id)}
                      disabled={!allProjects.some(p => p.id === project.id)}
                    />
                    <label htmlFor={`project-${project.id}`} className="form-check-label">
                      {project.name}
                    </label>
                  </div>
                ))
              )}
            </div>
            
            {loading && <div className="text-center mt-3">Сохранение...</div>}
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>Отмена</button>
            <button className="btn btn-primary" onClick={handleSave}>Сохранить</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectsModal;